/* eslint-disable-next-line */
import {JobCategoriesView, JobItemsView} from "./job-categories.view";
import {useQuery} from "@apollo/client";
import {JOB_CATEGORY_LIST} from "@betrue/shared/clients";
import {useState} from "react";
import {Job, JobCategory, Profile} from "@betrue/shared/interfaces";
import {usePersonView, useProfile} from "@betrue/front/services";
import {CircularProgress} from "@mui/material";

export interface JobCategoriesProps {


}

export const JobCategories = (props: JobCategoriesProps) => {
  const {loading, error, data, refetch} = useQuery(JOB_CATEGORY_LIST);
  const [selectedCategory, setSelectedCategory] = useState<JobCategory>(undefined)
  const filteredJobCategories = data?.jobCategories ? data.jobCategories : []
  const [, {addJobToProfile}] = useProfile<Profile>()
  const [, profileView] = usePersonView()


  const handleCategorySelection = (jc: JobCategory) => {
    setSelectedCategory(jc)
  }

  const handleJobSelection = (job: Job) => {
    addJobToProfile(job.id, profileView.id)
    setSelectedCategory(undefined)
  }

  if (!profileView) return (<><CircularProgress/></>)

  return (
    <>
      {selectedCategory ? (<JobItemsView onJobSelect={handleJobSelection} jobs={selectedCategory.jobs}/>) : (
        <JobCategoriesView onCategorySelected={handleCategorySelection} jobCategories={filteredJobCategories}/>)}
    </>
  );
}
